import { defineMessages } from 'react-intl';

export const jsmUseCaseTemplateChoiceMessages = defineMessages({
	header: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.header',
		defaultMessage: 'What do you want to set up first?',
	},
	subheader: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.subheader',
		defaultMessage:
			'Select an option to create your new space. You can set up more capabilities later.',
	},
	backButton: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.backButton',
		defaultMessage: 'Back',
	},
	selectButton: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.selectButton',
		defaultMessage: 'Select',
	},
	selectTemplateButton: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.selectTemplateButton',
		defaultMessage: 'Select {templateName}',
	},
	recommended: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.recommended',
		defaultMessage: 'Recommended',
	},
	customerServiceManagementTitle: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.customerServiceManagement.title',
		defaultMessage: 'Customer service management',
	},
	customerServiceManagementBenefitOne: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.customerServiceManagement.benefitOne',
		defaultMessage: 'Set up omnichannel support',
	},
	customerServiceManagementBenefitTwo: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.customerServiceManagement.benefitTwo',
		defaultMessage: 'Create a portal',
	},
	customerServiceManagementBenefitThree: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.customerServiceManagement.benefitThree',
		defaultMessage: 'Set up Rovo service agents',
	},
	serviceRequestManagementTitle: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.serviceRequestManagement.title',
		defaultMessage: 'Service request management',
	},
	serviceRequestManagementBenefitOne: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.serviceRequestManagement.benefitOne',
		defaultMessage: 'Set up a service space for requests',
	},
	serviceRequestManagementBenefitTwo: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.serviceRequestManagement.benefitTwo',
		defaultMessage: 'Manage incidents and requests',
	},
	serviceRequestManagementBenefitThree: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.serviceRequestManagement.benefitThree',
		defaultMessage: 'Set up Rovo service agents',
	},
	generalServiceManagementTitle: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.generalServiceManagement.title',
		defaultMessage: 'General service management',
	},
	generalServiceManagementBenefitOne: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.generalServiceManagement.benefitOne',
		defaultMessage: 'Manage requests across teams',
	},
	generalServiceManagementBenefitTwo: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.generalServiceManagement.benefitTwo',
		defaultMessage: 'Set up a shared service space',
	},
	generalServiceManagementBenefitThree: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.generalServiceManagement.benefitThree',
		defaultMessage: 'Track and resolve issues',
	},
	developmentRequestTitle: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.developmentRequest.title',
		defaultMessage: 'Development request',
	},
	developmentRequestBenefitOne: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.developmentRequest.benefitOne',
		defaultMessage: 'Sync new feature requests',
	},
	developmentRequestBenefitTwo: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.developmentRequest.benefitTwo',
		defaultMessage: 'Manage bug reports',
	},
	developmentRequestBenefitThree: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.developmentRequest.benefitThree',
		defaultMessage: 'Manage incidents in your backlog',
	},
	incidentManagementTitle: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.incidentManagement.title',
		defaultMessage: 'Incident management',
	},
	incidentManagementBenefitOne: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.incidentManagement.benefitOne',
		defaultMessage: 'Set up alerting and on-call',
	},
	incidentManagementBenefitTwo: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.incidentManagement.benefitTwo',
		defaultMessage: 'Map your services and dependencies',
	},
	incidentManagementBenefitThree: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.incidentManagement.benefitThree',
		defaultMessage: 'Manage changes and approvals',
	},
	hrServiceManagementTitle: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.hrServiceManagement.title',
		defaultMessage: 'HR service management',
	},
	hrServiceManagementBenefitOne: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.hrServiceManagement.benefitOne',
		defaultMessage: 'Manage change requests for staff',
	},
	hrServiceManagementBenefitTwo: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.hrServiceManagement.benefitTwo',
		defaultMessage: 'Manage onboarding workflows',
	},
	hrServiceManagementBenefitThree: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.hrServiceManagement.benefitThree',
		defaultMessage: 'Manage offboarding workflows',
	},
	designServiceManagementTitle: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.designServiceManagement.title',
		defaultMessage: 'Design service management',
	},
	designServiceManagementBenefitOne: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.designServiceManagement.benefitOne',
		defaultMessage: 'Customise design request types',
	},
	designServiceManagementBenefitTwo: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.designServiceManagement.benefitTwo',
		defaultMessage: 'Manage design reviews',
	},
	designServiceManagementBenefitThree: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.designServiceManagement.benefitThree',
		defaultMessage: 'Set up a knowledge base',
	},
	marketingServiceManagementTitle: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.marketingServiceManagement.title',
		defaultMessage: 'Marketing service management',
	},
	marketingServiceManagementBenefitOne: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.marketingServiceManagement.benefitOne',
		defaultMessage: 'Customise campaign request types',
	},
	marketingServiceManagementBenefitTwo: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.marketingServiceManagement.benefitTwo',
		defaultMessage: 'Manage asset requests',
	},
	marketingServiceManagementBenefitThree: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.marketingServiceManagement.benefitThree',
		defaultMessage: 'Manage review approvals',
	},
	analyticsServiceManagementTitle: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.analyticsServiceManagement.title',
		defaultMessage: 'Analytics service management',
	},
	analyticsServiceManagementBenefitOne: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.analyticsServiceManagement.benefitOne',
		defaultMessage: 'Tailor request types and forms',
	},
	analyticsServiceManagementBenefitTwo: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.analyticsServiceManagement.benefitTwo',
		defaultMessage: 'Manage data request',
	},
	analyticsServiceManagementBenefitThree: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.analyticsServiceManagement.benefitThree',
		defaultMessage: 'Track progress and queues',
	},
	salesServiceManagementTitle: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.salesServiceManagement.title',
		defaultMessage: 'Sales service management',
	},
	salesServiceManagementBenefitOne: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.salesServiceManagement.benefitOne',
		defaultMessage: 'Customise request channels',
	},
	salesServiceManagementBenefitTwo: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.salesServiceManagement.benefitTwo',
		defaultMessage: 'Manage quote reviews',
	},
	salesServiceManagementBenefitThree: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.salesServiceManagement.benefitThree',
		defaultMessage: 'Manage contract reviews',
	},
	financeServiceManagementTitle: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.financeServiceManagement.title',
		defaultMessage: 'Finance service management',
	},
	financeServiceManagementBenefitOne: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.financeServiceManagement.benefitOne',
		defaultMessage: 'Manage finance requests',
	},
	financeServiceManagementBenefitTwo: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.financeServiceManagement.benefitTwo',
		defaultMessage: 'Track budget and spend',
	},
	financeServiceManagementBenefitThree: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.financeServiceManagement.benefitThree',
		defaultMessage: 'Set up a knowledge base',
	},
	legalServiceManagementTitle: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.legalServiceManagement.title',
		defaultMessage: 'Legal service management',
	},
	legalServiceManagementBenefitOne: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.legalServiceManagement.benefitOne',
		defaultMessage: 'Set up an internal service space',
	},
	legalServiceManagementBenefitTwo: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.legalServiceManagement.benefitTwo',
		defaultMessage: 'Automate legal workflows',
	},
	legalServiceManagementBenefitThree: {
		id: 'ConfirmationPage.JsmUseCaseTemplateChoice.legalServiceManagement.benefitThree',
		defaultMessage: 'Manage employee requests',
	},
});
